<template>
  <a-modal
    :visible="visible"
    :title="id ? $t('modal.editTitle') : $t('modal.createTitle')"
    :destroy-on-close="true"
    :mask-closable="false"
    :closable="false"
    :width="'70%'"
    @cancel="handleCancel()"
  >
    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">
        {{ $t('modal.cancel') }}
      </a-button>
      <a-button key="submit" type="primary" :disabled="loading" :loading="loading" @click="handleSubmit">
        {{ id ? $t('modal.update') : $t('modal.create') }}
      </a-button>
    </template>
    <a-spin :spinning="loading">
      <div class="spin-content setting-modal">
        <a-form :form="form" @submit="handleSubmit">
          <a-row>
            <a-col :md="11" :xs="24">
              <a-form-item :label="$t('productManager.column.name')">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      initialValue: data ? data.name : '',
                      rules: [{ required: true, message: $t('productManager.validations.nameRequired') }]
                    }
                  ]"
                  maxlength="255"
                />
              </a-form-item>
            </a-col>
            <a-col :md="{span: 11, offset: 2}" :xs="24">
              <a-form-item :label="$t('productManager.column.price')">
                <a-input
                  v-decorator="[
                    'price',
                    {
                      initialValue: data ? data.price : '',
                      rules: [{ required: true, message: $t('productManager.validations.priceRequired') }]
                    }
                  ]"
                  maxlength="255"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="11" :xs="24">
              <a-form-item :label="$t('productManager.column.category_name')">
                <a-select
                  v-decorator="[
                    'category_id',
                    {
                      initialValue: data ? data.category_id : '',
                      rules: [{ required: true, message: $t('productManager.validations.categoryRequired') }]
                    }
                  ]"
                  :placeholder="$t('productManager.selectCategory')"
                  :allow-clear="true"
                  show-search
                >
                  <a-select-option v-for="category in categories" :key="category.id">
                    {{ category.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="{span: 11, offset: 2}" :xs="24">
              <a-form-item :label="$t('productManager.column.brand_name')">
                <a-select
                  v-decorator="[
                    'brand_id',
                    {
                      initialValue: data ? data.brand_id : '',
                      rules: [{ required: true, message: $t('productManager.validations.brandRequired') }]
                    }
                  ]"
                  :placeholder="$t('productManager.selectBrand')"
                  :allow-clear="true"
                  show-search
                >
                  <a-select-option v-for="brand in brands" :key="brand.id">
                    {{ brand.name }}
                  </a-select-option>>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="11" :xs="24">
              <a-form-item :label="$t('productManager.column.state_name')">
                <a-select
                  v-decorator="[
                    'state_id',
                    {
                      initialValue: data ? data.state_id : '',
                      rules: [{ required: true, message: $t('productManager.validations.stateRequired') }]
                    }
                  ]"
                  :placeholder="$t('productManager.selectState')"
                  :allow-clear="true"
                  show-search
                >
                  <a-select-option v-for="state in states" :key="state.id">
                    {{ state.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="{span: 11, offset: 2}" :xs="24">
              <a-form-item :label="$t('productManager.column.size')">
                <a-input
                  v-decorator="[
                    'size',
                    {
                      initialValue: data ? data.size : ''
                    }
                  ]"
                  maxlength="255"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="11" :xs="24">
              <a-form-item :label="$t('productManager.column.group_name')">
                <a-select
                  v-decorator="[
                    'group_id',
                    {
                      initialValue: data ? data.group_id : '',
                    }
                  ]"
                  :placeholder="$t('productManager.selectGroup')"
                  :allow-clear="true"
                  show-search
                >
                  <a-select-option v-for="group in groups" :key="group.id">
                    {{ group.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="{span: 11, offset: 2}" :xs="24">
              <a-form-item :label="$t('productManager.column.gender_name')">
                <a-select
                  v-decorator="[
                    'gender_id',
                    {
                      initialValue: data ? data.gender_id : '',
                    }
                  ]"
                  :placeholder="$t('productManager.selectGender')"
                  :allow-clear="true"
                  show-search
                >
                  <a-select-option v-for="gender in genders" :key="gender.id">
                    {{ gender.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="11" :xs="24">
              <a-form-item :label="$t('brandManager.column.description')">
                <a-textarea
                  v-decorator="[
                    'description',
                    {
                      initialValue: data ? data.description: ''
                    }
                  ]"
                  :rows="5"
                />
              </a-form-item>
            </a-col>
            <a-col :md="{span: 11, offset: 2}" :xs="24">
              <a-form-item :label="$t('productManager.column.image')">
                <div class="clearfix">
                  <a-upload
                    accept="image/*"
                    multiple="true"
                    list-type="picture-card"
                    :file-list="fileList"
                    :custom-request="customRequest"
                    @preview="handlePreview"
                    @change="handleChange"
                  >
                    <div v-if="fileList.length < 8">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">
                        Upload
                      </div>
                    </div>
                  </a-upload>
                  <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelPreview">
                    <img alt="example" style="width: 100%" :src="previewImage">
                  </a-modal>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import {
  StoreProduct as ApiStoreProduct,
  ShowProduct as ApiShowProduct,
  UpdateProduct as ApiUpdateProduct,
  UploadImage as ApiUploadImage
} from '@/api/products';
import { SearchCategory as ApiSearchCategory } from '@/api/categories';
import { SearchBrand as ApiSearchBrand } from '@/api/brands';
import { SearchGroup as ApiSearchGroup } from '@/api/groups';
import { SearchColor as ApiSearchColor } from '@/api/colors';
import { SearchGender as ApiSearchGender } from '@/api/genders';
import { SearchState as ApiSearchState } from '@/api/states';
import { genders, states } from '@/config/constants';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  name: 'ProductModal',
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      id: null,
      data: null,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      categories: [],
      brands: [],
      groups: [],
      // colors: [],
      genders: { ...genders },
      states: { ...states },
      loading: false
    };
  },
  methods: {
    getProduct() {
      this.loading = true;
      ApiShowProduct({ id: this.id })
        .then((response) => {
          this.data = response.data;
          this.fileList = [];
          const images = response.data.images;
          if (images && images.length > 0) {
            images.forEach(item => {
              this.fileList = [...this.fileList, { uid: item.uid, status: 'done', url: `${response.data.base_url}${item.url}` }];
            });
          }
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    showModal(id = null) {
      this.visible = true;
      this.id = id;
      this.clearData();
      if (id) {
        this.getProduct();
      }
      this.getCategorys();
      this.getBrands();
      this.getGroups();
      // this.getColors();
      // this.getGenders();
      // this.getStates();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields({ force: true }, (err, values) => {
        if (!err) {
          const apiName = this.id ? ApiUpdateProduct : ApiStoreProduct;
          if (this.id) {
            values.id = this.id;
          }
          let images = [];
          this.fileList.forEach(item => {
            images = [...images, { uid: item.uid, url: item.url }];
          });
          values.images = images;
          this.loading = true;
          apiName(values)
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$notification.success({ message: this.$t(`modal.successMessage.${this.id ? 'updateSuccess' : 'createSuccess'}`) });
              this.$emit('updateProductSuccess');
            })
            .catch((error) => {
              const { message } = error.response.data;
              // Show error message
              this.$error({
                title: this.$t('modal.failModal.title'),
                content: message,
                okText: this.$t('modal.failModal.close')
              });
              this.loading = false;
            });
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    clearData() {
      this.form.resetFields();
    },
    handleCancelPreview() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    customRequest({ file }) {
      const formData = new FormData();
      formData.append('images[0]', file);
      this.loading = true;
      ApiUploadImage(formData)
        .then((response) => {
          this.loading = false;
          this.fileList.map(item => {
            if (item.uid === file.uid) {
              item.status = 'done';
              item.url = response[0];
            }
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    getCategorys() {
      this.loading = true;
      ApiSearchCategory()
        .then((response) => {
          const { data } = response;
          this.categories = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBrands() {
      this.loading = true;
      ApiSearchBrand()
        .then((response) => {
          const { data } = response;
          this.brands = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getGroups() {
      this.loading = true;
      ApiSearchGroup()
        .then((response) => {
          const { data } = response;
          this.groups = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getColors() {
      this.loading = true;
      ApiSearchColor()
        .then((response) => {
          const { data } = response;
          this.colors = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getGenders() {
      this.loading = true;
      ApiSearchGender()
        .then((response) => {
          const { data } = response;
          this.genders = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getStates() {
      this.loading = true;
      ApiSearchState()
        .then((response) => {
          const { data } = response;
          this.states = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
    .setting-modal {
        .ant-form-item {
            margin: 0 0 15px !important;
        }
        .ant-form-item-label {
            line-height: 25px !important;
        }
    }
    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
</style>
